var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLexusInfo = function SvgLexusInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#101010",
    fillRule: "evenodd",
    d: "M8.5 16.029A7.529 7.529 0 1 0 8.5.97a7.529 7.529 0 0 0 0 15.058m0 .971a8.5 8.5 0 1 0 0-17 8.5 8.5 0 0 0 0 17",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#101010",
    fillRule: "evenodd",
    d: "M8.971 6.885v6.678H8V6.885zM8.971 4v1.214H8V4z",
    clipRule: "evenodd"
  })));
};
export default SvgLexusInfo;